import { CHECKED_ADDRESS, DEL_ADDRESS } from '../constants/address'

export default function address(state = {}, action) {
    if (action.type === CHECKED_ADDRESS) {
        return {...state, ...action.item};
    } else if (action.type === DEL_ADDRESS) {
        return {};
    }
    return state;
}